import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-fact-value',
  standalone: true,
  imports: [],
  templateUrl: './fact-value.component.html',
  styleUrls: [
    '../fact-header/fact-header.component.scss',
    './fact-value.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FactValueComponent {
  factValue = input.required<string>();
  published = input.required<string>();
  expected = input.required<string>();
}
